import React from 'react';

export default () => (
  <svg fill='inherit' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30' width='30px' height='30px'><path d='M24 25H6c-1.105 0-2-.895-2-2v-2h22v2C26 24.105 25.105 25 24 25zM15 2A2 2 0 1 0 15 6 2 2 0 1 0 15 2zM27 7A2 2 0 1 0 27 11 2 2 0 1 0 27 7zM3 7A2 2 0 1 0 3 11 2 2 0 1 0 3 7z'/><path d='M23 19L7 19 15 4z'/><path d='M26 19L10 19 27 9z'/><path d='M4 19L20 19 3 9z'/></svg>
);
